<template>
    <div class="c-search-page__results-container" v-if="!loading">
      <h1 class="c-search-page__results-label">
        Found {{ total + workTextsTotal }} {{ searchTermsUsed }}
      </h1>
      <p class="c-search-page__results-suggestion" v-if="isOnAllTab()">
        Want to search Shakespeare’s plays and poems? 
        <a :href="searchWorksLink()" class="c-link">
            Use the Shakespeare’s Works tab.
        </a>
      </p>
    </div>
</template>

<script>
    import {EventBus} from "../event-bus";

    export default {
        name: "Statistics",
        props: ["area"],
        watch: {
            "area": function (val, oldVal) {
                if (val !== oldVal) {
                    this.filters = {}
                    this.loading = true
                    this.total = 0
                    this.workTextsTotal = 0
                }
            }
        },
        data() {
            return {
                loading: true,
                total: 0,
                workTextsTotal: 0,
                searchTerms: [],
                filters: {},
            }
        },
        computed: {
            searchTermsUsed() {
                let output = ''
                let result = this.total + this.workTextsTotal === 1 ? 'result' : 'results'

                if (this.searchTerms.length > 0) {

                    this.searchTerms.map((term, index, array) => {
                        if (term.length > 0) {
                            let concatenate = ' '
                            if (index === array.length - 1 && index !== 0) {
                                concatenate = ' and '
                            } else if (index !== 0) {
                                concatenate = ', '
                            }
                            let termLabel = this.termLabel(term);
                            output = output + concatenate + termLabel.split('-').join(' ')
                        }
                    })

                    return output ? result + ' for: ' + output : ''
                }

                return result
            },
        },
        mounted() {
            EventBus.$on('filters-populated', filters => this.filters = filters)
            EventBus.$on('update-stats', data => {
                this.loading = false
                this.total = data.total
                this.updateSearchTerms(data.searchTerms)
            })
            EventBus.$on('new-search', () => {
                this.loading = true
            })
            EventBus.$on('update-results-count', count => {
                this.total = count
            })
            EventBus.$on('update-text-results-count', count => {
                this.workTextsTotal = count
            })
        },
        methods: {
            searchWorksLink() {
              const url = `${window.location.origin}${window.location.pathname}`
              const urlParams = new URLSearchParams(window.location.search)

              if (urlParams.has('q')) {
                urlParams.append('area', 'works')
                return `${url}?${urlParams.toString()}`
              }

              return url
            },
            termExist(term) {
                return this.searchTerms.some(element => element === term)
            },
            termLabel(term) {
                let termLabel = '';
                if (Object.keys(this.filters).length > 0) {
                    for (const key of Object.keys(this.filters)) {
                        let filterTerms = this.filters[key].terms
                        if (Array.isArray(filterTerms)) {
                            filterTerms.forEach(filterTerm => {
                                if (filterTerm.slug === term) {
                                    termLabel = filterTerm.name
                                }
                            })
                        } else {
                            for (const [key, filterTerm] of Object.entries(filterTerms)) {
                                if (filterTerm && !Array.isArray(filterTerm.children)) {
                                    let children = filterTerm.children
                                    for (const [key, childTerm] of Object.entries(children)) {
                                        if (childTerm.slug === term) {
                                            termLabel = childTerm.name
                                        }
                                    }
                                } else {
                                    if (filterTerm.slug === term) {
                                        termLabel = filterTerm.name
                                    }
                                }
                            }
                        }
                    }
                    return termLabel ? termLabel : term
                } else {
                    return term
                }
            },
            updateSearchTerms(terms) {
                this.searchTerms = []
                for (const [key, value] of Object.entries(terms)) {
                    if (Array.isArray(value)) {
                        value.forEach(element => this.searchTerms.push(element))
                    } else if (key !== 'area') {
                        if (value) {
                            if (key === 'q') {
                                this.searchTerms.unshift(value)
                            } else {
                                this.searchTerms.push(value)
                            }
                        }
                    }
                }
            },
            isOnAllTab() {
              return this.area === ''
            },
        }
    }
</script>

<style scoped>

</style>
